import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import isEmailProper from '../../utils/isEmailProper';

import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import { PrimaryButton } from '../misc/Buttons';
import { FormattedMessageWrappedInSpan } from '../misc';

import { MAGIC_LINK_EXPLANATION_MSG } from '../../utils/variables';
import { getFromLocalStorage } from '../../utils/browser-storage';

const ENTER_KEY = 'Enter';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: getFromLocalStorage('email') || '',
      accessToken: getFromLocalStorage('accessToken'),
      showEmailErrorMessage: false,
    };
  }

  handleEmailChange = (event) => {
    if (this.state.showEmailErrorMessage) {
      this.setState({
        showEmailErrorMessage: false,
        email: event.target.value.trim(),
      });
    } else {
      this.setState({ email: event.target.value.trim() });
    }
  };

  handleEmailKeypress = (event) => {
    if (event.key === ENTER_KEY) {
      this.handleSendMlClicked();
    }
  };

  handleSendMlClicked = () => {
    const { email } = this.state;

    if (
      !isEmailProper(email)
    ) {
      this.setState({ showEmailErrorMessage: true });
      return;
    }

    this.props.onRequestLogin(email.trim());
  };

  getEmailErrorMessage = () => {
    const { email, showEmailErrorMessage } = this.state;
    const { intl } = this.props;

    if (showEmailErrorMessage) {
      if (!email) {
        return intl.formatMessage(translations.inputErrorText);
      }

      if (
        !isEmailProper(email)
      ) {
        return intl.formatMessage(translations.invalidEmailText);
      }
    }
    return false;
  };

  render() {
    const { intl, isLoginPage, onOpenNotificationDialog, isLinkSending, linkSentSuccess } = this.props;
    const { email, showEmailErrorMessage } = this.state;

    return (
      <div className="login-form-container">
        <TextField
          autoFocus={isLoginPage && !email}
          classes={{ root: 'login-textfield' }}
          value={email || ''}
          name="email"
          fullWidth
          label={intl.formatMessage(translations.enterEmailHint)}
          onChange={this.handleEmailChange}
          onKeyPress={this.handleEmailKeypress}
          error={showEmailErrorMessage}
          helperText={this.getEmailErrorMessage()}
        />
        <PrimaryButton
          leftLabel={
            linkSentSuccess ? (
              <FormattedMessageWrappedInSpan
                id="notificationDialogBody.verifyEmailNextSteps.title"
                defaultMessage="Link sent"
              />
            ) : 
            isLinkSending ? 
              (<CircularProgress  
                color={'white'}
                size={20}
                thickness={3} 
              />
              ) : (
              <FormattedMessageWrappedInSpan
                id="loginForm.login"
                defaultMessage="Send Magic Link"
              />
            )
          }
          onClick={this.handleSendMlClicked}
          disabled={linkSentSuccess || isLinkSending}
        />
        <div
          className="explanation"
          onClick={() => {
            onOpenNotificationDialog(MAGIC_LINK_EXPLANATION_MSG);
          }}
        >
          <FormattedMessageWrappedInSpan
            id="loginForm.magicLink.title"
            defaultMessage="What is a magic link?"
          />
        </div>
      </div>
    );
  }
}

LoginForm.defaultProps = {
  isLoginPage: false,
};

LoginForm.propTypes = {
  intl: PropTypes.object,
  isLoginPage: PropTypes.bool,
  onRequestLogin: PropTypes.func,
  onOpenNotificationDialog: PropTypes.func,
  linkSentSuccess: PropTypes.bool,
  isLinkSending: PropTypes.bool,
};

const translations = defineMessages({
  enterEmailHint: {
    id: 'loginForm.enterEmailHint',
    defaultMessage: 'Enter your email',
  },
  inputErrorText: {
    id: 'loginForm.magicLink.inputErrorText',
    defaultMessage: 'This field is required',
  },
  invalidEmailText: {
    id: 'loginForm.magicLink.invalidEmailText',
    defaultMessage: 'Please enter a valid email',
  },
});

export default injectIntl(LoginForm);
